import { IAdvertRepository, KeptAttachmentDTO } from '../ports/IAdvertRepository';
import { AdvertEntity } from '../../domain/entities/Advert';
import { AdvertTitle } from '../../domain/value-objects/AdvertTitle';

export interface UpdateAdvertInput {
  uuid: string;
  title: string;
  description: string;
  attachments: { file: File | Blob; mimeType: string; position?: number; }[];
  keepAttachments?: KeptAttachmentDTO[];
}

const extFromMime = (mt: string) => {
  if (!mt) return '';
  const map: Record<string, string> = { 'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'video/mp4': 'mp4', 'video/quicktime': 'mov' };
  return map[mt] ? `.${map[mt]}` : '';
};

export class UpdateAdvertUseCase {
  constructor(private repo: IAdvertRepository) {}
  async execute(input: UpdateAdvertInput): Promise<AdvertEntity> {
    const title = AdvertTitle.create(input.title);
    return this.repo.update({
      uuid: input.uuid,
      title: title.Value,
      description: input.description,
      attachments: input.attachments.map((a, i) => {
        const name = (a.file as any)?.name || `attachment_${i}${extFromMime(a.mimeType)}`;
        return { fileName: name, mimeType: a.mimeType, data: a.file, position: a.position ?? i };
      }),
      keepAttachments: input.keepAttachments ?? [],
    });
  }
}
